import { pipeAddMuscles } from "./index33.js";
import { pipeTailor } from "./index70.js";
import { nelderMead } from "./index71.js";
import { getRatiosFromData } from "./index72.js";
import { recursiveSubdivisionFromData } from "./index78.js";
import { DefaultPlot, GetAllMuscles, RG_TYPE, RgCreate, getRgObjectsOfType } from "@project-rouge/rg-core";
import { MuscleToVector, Vector3toV3, intersectPolygons } from "@project-rouge/rg-three";
import { MathUtils, Vector3 } from "three";
const optimisePlots = (zone, aggProps, divisionData) => {
	const tailorDataOut = {
		mainThreads: [],
		mainFrozenThreads: []
	};
	const rvData = aggProps.dataset.rvData;
	clearZone(zone);
	const tempAggProps = {
		...aggProps,
		zones: Object.fromEntries(Object.entries(aggProps.zones).filter((z) => z[0] === zone.uuid))
	};
	for (let i = 0; i < zone.data.polygons.length; i++) {
		const data = divisionData[i];
		const x0 = getRatiosFromData(data).slice();
		function f(x) {
			clearZone(zone);
			let newPlotPolys$1 = recursiveSubdivisionFromData(data, x.map((v) => MathUtils.clamp(v, 0, 1)).slice());
			newPlotPolys$1 = retrimPolys(zone, i, newPlotPolys$1);
			createPlots(newPlotPolys$1, zone, i, rvData);
			pipeTailor([zone, { aggProps: tempAggProps }]);
			pipeAddMuscles([zone, { aggProps: tempAggProps }]);
			return -score(zone);
		}
		const resultRatios = nelderMead(f, x0, { maxIterations: 10 }).x.point;
		clearZone(zone);
		let newPlotPolys = recursiveSubdivisionFromData(data, resultRatios);
		newPlotPolys = retrimPolys(zone, i, newPlotPolys);
		createPlots(newPlotPolys, zone, i, rvData);
		const [, tailorData] = pipeTailor([zone, { aggProps: tempAggProps }]);
		tailorDataOut.mainThreads.push(...tailorData.mainThreads);
		tailorDataOut.mainFrozenThreads.push(...tailorData.mainFrozenThreads);
	}
	return {
		parent: zone,
		tailorDataOut
	};
};
function retrimPolys(zone, i, plotPolys) {
	let newPlotPolys = [];
	const originalZonePolygon = zone.data.polygons[i].map(Vector3toV3);
	newPlotPolys = plotPolys.map((poly) => poly.map(Vector3toV3)).flatMap((c) => intersectPolygons(originalZonePolygon, [c]));
	return newPlotPolys;
}
function createPlots(newPlotPolys, zone, i, rvData) {
	for (const polygon of newPlotPolys) {
		const plot = RgCreate({
			...DefaultPlot,
			parent: zone,
			data: {
				polygon,
				zonePolyIndex: i
			}
		}, rvData);
		zone.children.push(plot);
	}
}
var mVector = new Vector3();
function score(obj) {
	const buildings = getRgObjectsOfType(obj, RG_TYPE.Building);
	let totalLength = 0;
	for (const b of buildings) {
		const muscles = GetAllMuscles(b.data.anatomy);
		totalLength += muscles.reduce((sum$1, m) => sum$1 + MuscleToVector(m, mVector).length(), 0);
	}
	return totalLength;
}
function clearZone(zone) {
	zone.children.length = 0;
}
export { optimisePlots };

//# sourceMappingURL=index79.js.map